import React, { useState } from 'react';
import { supabase } from './supabaseClient';

const FONT = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';

export default function LoginGate({ children }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleGoogle() {
    setLoading(true);
    setError('');
    const { error: e } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
        queryParams: { hd: 'sanoire.com' },
      },
    });
    if (e) { setError(e.message); setLoading(false); }
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#0d1e28', display: 'flex',
      alignItems: 'center', justifyContent: 'center', fontFamily: FONT,
    }}>
      <div style={{
        background: '#0a1820', border: '1px solid rgba(175,225,246,0.12)',
        borderRadius: 16, padding: '40px 36px', width: 360, textAlign: 'center',
      }}>
        {/* Wordmark */}
        <svg viewBox="0 0 1080 164.33" style={{ height: 22, width: 'auto', display: 'block', margin: '0 auto 8px' }}>
          <defs><style>{'.wl{fill:#e0f5fc}'}</style></defs>
          <path className="wl" d="M63.72,133.19c15.09,0,24.19-7.43,24.19-17.25,0-34.25-83.12-9.58-83.12-70.19C4.79,19.64,28.99,0,61.32,0s57.73,22.28,57.73,48.87h-35.93c0-8.86-9.34-17.73-21.8-17.73s-21.8,6.23-21.8,14.61c0,29.94,84.32,11.5,84.32,66.35,0,29.94-26.83,52.22-62.52,52.22S0,138.94,0,105.16h34.73c0,16.05,9.1,28.03,28.99,28.03Z"/>
          <path className="wl" d="M270.32,159.54v-15.33c-6.95,8.62-27.31,19.88-49.11,19.88-40.24,0-76.89-36.65-76.89-81.69S180.97,1.2,226.01,1.2s79.05,36.41,79.05,81.21v77.13h-34.73ZM226.01,132.95c24.91,0,45.75-21.8,45.75-50.54s-20.84-50.06-45.75-50.06-45.75,21.56-45.75,50.06,20.84,50.54,45.75,50.54Z"/>
          <path className="wl" d="M411.01,31.38c-21.32,0-35.69,14.85-35.69,37.13v91.03h-34.73v-91.03C340.58,27.79,368.85.48,411.01.24c42.16.24,70.43,27.55,70.43,68.27v91.03h-34.73v-91.03c0-22.28-14.37-37.13-35.69-37.13Z"/>
          <path className="wl" d="M510.01,82.4c0-44.79,36.65-81.21,81.68-81.21s81.69,36.41,81.69,81.21-36.65,81.69-81.69,81.69-81.68-36.65-81.68-81.69ZM591.69,132.95c24.91,0,45.75-21.8,45.75-50.54s-20.84-50.06-45.75-50.06-45.75,21.56-45.75,50.06,20.84,50.54,45.75,50.54Z"/>
          <path className="wl" d="M738.87,3.83v155.7h-34.74V3.83h34.74Z"/>
          <path className="wl" d="M846.73.24v31.14c-21.32,0-35.69,14.85-35.69,37.13v91.03h-34.73v-91.03c0-40.72,28.27-68.03,70.42-68.27Z"/>
          <path className="wl" d="M940.3,164.09c-45.03,0-81.68-36.65-81.68-81.69S895.26,1.2,940.3,1.2c41.44,0,86.72,34.73,80.49,92.7h-125.04c4.55,22.76,23,39.05,44.55,39.05,17.49,0,33.06-10.78,40.48-27.55h37.37c-9.82,33.77-40.96,58.69-77.85,58.69ZM982.7,64.92c-6.23-19.64-23-32.58-42.4-32.58s-36.65,13.17-43.12,32.82l85.52-.24Z"/>
          <path className="wl" d="M1058.5,9.54c5.33,0,9.31,3.43,9.31,7.99,0,4.06-3.15,7.22-7.62,7.85l9.09,10.78h-6.12l-8.98-10.65h-2.97v10.65h-5.19V9.54h12.49ZM1058.5,21.18c2.26,0,3.94-1.56,3.94-3.66s-1.68-3.66-3.94-3.66h-7.3v7.32h7.3Z"/>
          <path className="wl" d="M1056.54,47.07c-12.94,0-23.46-10.52-23.46-23.46S1043.6.15,1056.54.15s23.46,10.52,23.46,23.46-10.52,23.46-23.46,23.46ZM1056.54,3.13c-11.29,0-20.48,9.19-20.48,20.48s9.19,20.48,20.48,20.48,20.48-9.19,20.48-20.48-9.19-20.48-20.48-20.48Z"/>
        </svg>
        <div style={{ fontSize: '.7rem', color: 'rgba(175,225,246,0.35)', letterSpacing: '.08em', marginBottom: 32 }}>
          Admin Console
        </div>
        <div style={{ fontSize: '1.1rem', fontWeight: 300, color: '#e8f5ff', marginBottom: 8 }}>
          Sign in to continue
        </div>
        <div style={{ fontSize: '.78rem', color: 'rgba(175,225,246,0.45)', marginBottom: 28, lineHeight: 1.5 }}>
          Access restricted to @sanoire.com accounts
        </div>
        {error && (
          <div style={{ background: 'rgba(224,92,92,0.15)', border: '1px solid rgba(224,92,92,0.3)', borderRadius: 8, padding: '8px 12px', fontSize: '.74rem', color: '#f09595', marginBottom: 16 }}>
            {error}
          </div>
        )}
        <button
          onClick={handleGoogle}
          disabled={loading}
          style={{
            width: '100%', padding: '12px 0', borderRadius: 10,
            background: loading ? 'rgba(175,225,246,0.08)' : '#AFE1F6',
            color: loading ? 'rgba(175,225,246,0.4)' : '#071318',
            border: 'none', fontSize: '.9rem', cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: FONT, fontWeight: 500, transition: 'all .15s',
          }}
        >
          {loading ? 'Signing in…' : 'Continue with Google'}
        </button>
        <div style={{ fontSize: '.65rem', color: 'rgba(175,225,246,0.2)', marginTop: 20 }}>
          admin.sanoire.com
        </div>
      </div>
    </div>
  );
}
